import { render, staticRenderFns } from "./NavStdWallet.vue?vue&type=template&id=60fb9f94&scoped=true&"
import script from "./NavStdWallet.vue?vue&type=script&lang=js&"
export * from "./NavStdWallet.vue?vue&type=script&lang=js&"
import style0 from "./NavStdWallet.vue?vue&type=style&index=0&id=60fb9f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb9f94",
  null
  
)

/* custom blocks */
import block0 from "./NavStdWallet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports